import { createContext, useContext } from 'react'

/**
 * Free of any `@tanstack/react-form` import: __root.tsx mounts FormOptionalLabelProvider eagerly and must not
 * drag form-core into the entry chunk. form/shared.tsx re-exports these for the form-field components.
 */
const FormReadOnlyContext = createContext(false)
export const FormReadOnlyProvider = FormReadOnlyContext.Provider
export const useFormReadOnly = () => useContext(FormReadOnlyContext)

const FormOptionalLabelContext = createContext('Optional')
export const FormOptionalLabelProvider = FormOptionalLabelContext.Provider
export const useFormOptionalLabel = () => useContext(FormOptionalLabelContext)
